module.exports = __webpack_public_path__ + "img/indonesian-avocado-milkshake.c7569f63.jpg";